/**
 * i18n Basic translation
 * All kind of strings that are very used and shown in multiple apps
 */

import { Book } from '../../constants/translation';

// @todo description reading, no lines explanation, image text and explanation, line text and explanation
// @todo Licencia editorial para esta edición electrónica, por cortesía de Edhasa
// @todo notas tipo (1), (2), (i)

const translation = {
  es: {
    authors: 'Richard Wilhelm, traducido al español y notas por D.J. Vogelmann',
    rights: {
      text:
        '© Eugen Diederichs Verlag, Düsseldorf, 1960\n© Editorial Sudamericana, S.A., Buenos Aires, 1976\n© Edhasa, 1977',
      explanation:
        'Reproducción mínima para no infringir Copyright, por cortesía de Edhasa'
    },
    '1': {
      title: 'Lo creativo',
      description:
        'De acuerdo con su sentido primitivo, los atributos aparecen agrupados por pares. Para el que obtiene este oráculo, ello significa que el logro será otorgado desde las profundidades primordiales del acontecer universal, y que todo dependerá de que sólo mediante la perseverancia en lo recto busque su propia dicha y la de los demás.\n Ya antiguamente fueron objeto de meditación estas cuatro cualidades intrínsecas en razón de sus significaciones específicas. La palabra china que se reproduce por «elevado», significa «cabeza, origen, grande». Por eso en la explicación de Kung Tse se lee: «Grande en verdad es la fuerza original de lo creativo, todos los seres le deben su comienzo. Y todo el cielo está compenetrado de esta fuerza». Esta primera cualidad traspasa, por otra parte, a las otras tres.\n El comienzo de todas las cosas reside todavía, por así decirlo, en el más allá, en forma de ideas que aún deben llegar a realizarse. Pero en lo creativo reside también la fuerza destinada a dar forma a estas imágenes primarias de las ideas. Es lo que queda señalado con la palabra «logro», «éxito». Este proceso se ve representado por medio de una imagen de la naturaleza. «Pasan las nubes y actúa la lluvia y todos los seres individuales penetran como una corriente en las formas que les son propias(2).»\nTransferidas al terreno humano, estas cualidades muestran al gran hombre en camino hacia el gran éxito: «Al contemplar con plena claridad las causas y los efectos, él consume en tiempo justo las seis etapas y asciende en tiempo justo por estos seis peldaños como sobre seis dragones, elevándose al cielo». Los seis peldaños son las seis posiciones individuales del signo, que más adelante se representan bajo la imagen del dragón. Como camino hacia el logro aparece aquí el reconocimiento y la realización del sentido del universo que, en cuanto ley perenne, y a través de fines y comienzos, origina todos los fenómenos condicionados por el tiempo. De este modo, toda etapa alcanzada se convierte a la vez en preparatoria para la siguiente, y así el tiempo ya no constituye un obstáculo, sino el medio para la realización de lo posible.\nLuego de haberse expresado el acto de la creación a través de las dos cualidades «elevado» y «logro», se nos señala la obra de conservación, como un desenvolvimiento que se va elaborando en continua realización, como ligado a las dos expresiones «propiciado», esto es literalmente «creando lo que corresponde a la esencia», y «perseverante», que equivale literalmente a «recto y firme». «El curso de lo creativo modifica y forma a los seres hasta que cada uno alcanza la correcta naturaleza que le está destinada, y luego los mantiene en concordancia con el gran equilibrio. Así es como se muestra propicio por medio de la perseverancia.»\nTrasladando lo dicho al terreno humano, podemos comprender cómo el gran hombre, mediante su actividad ordenadora, trae al mundo paz y seguridad: «Al elevar la cabeza sobre la multitud de seres, todas las comarcas juntas entran en calma».\nOtra explicación va más lejos aún con la separación de las voces «elevado, logro, estimulante, perseverante» y las parangona con las cuatro virtudes cardinales humanas: a la «elevación» que, como principio fundamental, involucra al mismo tiempo todas las demás cualidades, se le coordina el amor; a la cualidad «logro» se le coordinan las costumbres morales que ordenan las expresiones del amor, las organizan y las llevan así al éxito; a la cualidad «estimulante», «propicio», se le adjudica la justicia, creadora de circunstancias en las que cada cual obtiene aquello que corresponde a su naturaleza, aquello que le pertenece y hace su dicha; a la cualidad «perseverancia» se le coordina la sabiduría, que reconoce las leyes firmes vigentes en todo lo que acontece, y es por ello capaz de crear estados duraderos.\nEstas especulaciones sugeridas ya en el tratado Wen Yen que figura en la segunda parte del Libro de las Mutaciones, formaron más tarde el puente sobre el cual la filosofía de las cinco etapas de mutación (elementos) -que arraiga en el Libro de los Documentos o Crónicas- se combinó con la filosofía del Libro de las Mutaciones, que descansa puramente en la dualidad polar de principios positivos y negativos, hecho que luego, con el transcurso del tiempo, abriría las puertas a una simbología numerológica cada vez más amplia (1)',
      judgement:
        'Lo creativo obra elevado logro, propiciado por la perseverancia (1).',
      explanation:
        'El signo se compone de seis trazos no partidos. Los trazos no partidos corresponden a la protoenergía o energía primaria, luminosa, fuerte, espiritual, activa. El signo es total y uniformemente fuerte en su naturaleza. Puesto que no lo afecta ninguna debilidad, es, en sí mismo, de acuerdo con su cualidad intrínseca, la fuerza, la energía. Su imagen es el cielo. La fuerza, la energía, se representa como entidad no condicionada por determinadas circunstancias espaciales. Se la concibe por lo tanto como movimiento. Debe considerarse como fundamento de este movimiento el tiempo. Así pues, el signo involucra también el poder del tiempo y el poder de la perseveración en el tiempo, de la duración.\nEn la exégesis del signo ha de tenerse en cuenta, constantemente, una doble interpretación. La macrocósmica y la que corresponde a la acción en el mundo humano. Con respecto al acontecer universal, se expresa en el signo la fuerte acción creativa de la divinidad. Aplicado el signo al mundo humano, denota la acción creadora del santo y del sabio, el gobernante y conductor de hombres, que merced a su fuerza despierta y desarrolla en estos últimos su esencia más elevada.\n(1) El signo se adjudica al cuarto mes (mayo-junio), época en que la fuerza luminosa alcanza su culminación, antes que el solsticio dé comienzo al retroceso del año.',
      image: {
        text:
          'Pleno de fuerza es el movimiento del cielo. Así el noble se hace fuerte e infatigable.',
        explanation:
          "La duplicación del signo ch 'ien, cuya imagen es el cielo, indica, puesto que existe un solo cielo, el movimiento del cielo. Un movimiento circular completo del cielo es un día. La duplicación del signo implica que a cada día sigue otro día, lo cual engendra la representación del tiempo y, simultáneamente, puesto que se trata del mismo cielo que se mueve con fuerza infatigable, la representación de la duración, plena de fuerza, en el tiempo y más allá del tiempo, de un movimiento que jamás se detiene ni se paraliza, así como los días se siguen unos a otros a perpetuidad. Esta duración en el tiempo da la imagen de la fuerza tal como le es propicia a lo creativo.\nEl sabio extrae de ello el modelo según el cual deberá evolucionar hacia una acción duradera. Ha de hacerse íntegramente fuerte, eliminando a conciencia todo lo degradante, todo lo vulgar. Así adquiere la infatigabilidad que se basa en ciclos completos de actividad.\n(i) Lo creativo obra el principio, el engendramiento de todos los seres. Puede designarse por lo tanto como cielo, fuerza luminosa, padre, señor. La cuestión que ahora se plantea es si lo creativo, en chino, conforma una idea personificada como es el caso de Zeus entre los griegos. La respuesta es que semejante problema no es realmente importante desde el punto de vista del carácter chino. L o divino, lo creativo, es por así decirlo suprapersonal. Sólo se hace sentir y notar a raíz de su sumamente poderosa actividad. Es verdad que en cierto modo posee una manifestación externa, que es el cielo. Y el cielo, como todo lo viviente, posee una autoconciencia anímica, que es Dios (el supremo soberano). Pero, de un modo totalmente objetivo, se habla de todo esto como de lo creativo."
      },
      lines: {
        explanation:
          'Las líneas se cuentan desde abajo hacia arriba. El trazo del comienzo es, pues, el de más abajo. Si el consultante obtiene un siete, se trata por cierto de un trazo fuerte que se toma en consideración en cuanto a la estructura del signo en su totalidad, pero este trazo no se mueve y no tiene, por tanto, significación individual. Si, en cambio, el consultante obtiene un nueve, el trazo se mueve, destacándose con ello su significación peculiar y debiendo tenérselo en cuenta y meditar sobre él, en calidad de trazo individual. Lo mismo vale encuanto a las demás líneas fuertes en todo el libro. En cada uno de los hexagramas las dos líneas de abajo significan la tierra; las del medio, la región del mundo humano; las de arriba, el cielo.',
        detail: [
          {
            text: 'Dragón cubierto. No actúes.',
            explanation:
              'El dragón tiene en China un significado muy distinto del que le corresponde en la concepción occidental. El dragón es el símbolo de la energía móvil-eléctrica, fuerte e incitante, que se manifiesta en la tormenta. En el invierno esta energía se retira al interior de la tierra; con los comienzos del verano reinicia su acción y aparece en el cielo como rayo y trueno. En consecuencia, también sobre la tierra se movilizan entonces de nuevo las fuerzas creadoras.\nAquí, esta fuerza creadora aparece cubierta todavía; estando bajo la superficie de la tierra, todavía no actúa. Transferido a circunstancias humanas, esto significa que un hombre importante aún no obtiene reconocimiento. No obstante, permanece fiel a sí mismo.\nNo permite que influyan sobre él éxitos y fracasos exteriores.\nAntes bien, fuerte y despreocupado, espera que llegue su hora.\nPor lo tanto, alguien a quien le toca en suerte este trazo ha de aguardar con tranquila y fuerte paciencia. Sin duda su tiempo se cumplirá y llegará su día. No debe temerse que una fuerte voluntad pueda no llegar a imponerse. Pero es necesario no gastar la energía antes de tiempo en un intento de forzar la obtención de algo cuya hora todavía no ha llegado.'
          },
          {
            text:
              'Dragón que aparece sobre el campo. Es propicio ver al gran hombre.',
            explanation:
              'Aquí comienzan a mostrarse los efectos de la fuerza luminosa. Aplicado a circunstancias humanas, esto significa que el gran hombre aparece en el campo de su actividad; todavía no ocupa ninguna posición gobernante, todavía se halla entre sus iguales, pero lo que lo distingue ante los demás es su seriedad, su absoluta responsabilidad y el influjo que sin esfuerzo consciente alguno ejerce sobre quienes lo rodean. Un hombre tal está predestinado a llegar a tener gran influencia y a conducir el mundo hacia el orden. Por eso es propicio verlo.'
          },
          {
            text:
              'El noble es creativamente activo todo el día. Aun por la noche lo embarga la preocupación interior. Peligro. Ninguna tacha.',
            explanation:
              'Al hombre importante se le abre un círculo de acción. Comienza a difundirse su fama. Las multitudes se vuelcan a él. Su fuerza interior se halla a la altura de la incrementada actividad exterior. Hay muchísimo que hacer y aun hacia la noche, cuando ya otros descansan, se acumulan los planes y las preocupaciones. En este momento del tránsito desde lo bajo hacia las alturas aparece un peligro. Ya más de un hombre grande encontró su perdición en el hecho de que las masas se volcaran a él y lo arrastraran hacia sus propias vicisitudes. En tales casos la ambición corrompe la pureza interior. Pero las tentaciones no hacen mella a una verdadera grandeza. Si uno permanece alerta, en empatia con los gérmenes del tiempo nuevo y sensible frente a sus requerimientos, tendrá la suficiente cautela como para cuidarse de desviaciones y así quedará sin tacha, sin defecto.'
          },
          {
            text: 'Vacilante elevación sobre el precipicio. Ninguna tacha.',
            explanation:
              'Aquí se ha alcanzado ese punto de la transición donde puede entrar en acción la libertad. Una doble posibilidad se abre ante el hombre importante: o bien elevarse de un salto y tener decisiva significación en la vida en gran escala, o bien retirarse y cultivar su personalidad en silencio: el camino del héroe o el del santo oculto. No existe ninguna ley que decida cuál es el camino justo. Todo el que se encuentre en semejante situación ha de decidirlo libremente de acuerdo con las leyes más íntimas de su naturaleza. Si obra con entera veracidad y consecuencia, encontrará el camino que le corresponde y éste será para él la vía justa e intachable.'
          },
          {
            text:
              'Dragón que vuela en el cielo. Es propicio ver al gran hombre.',
            explanation:
              'Aquí el gran hombre ha arribado a la esfera de los seres celestiales. Su influjo se extiende, visible a lo lejos, sobre el mundo entero. Todo el que lo contemple puede considerarse bienaventurado.\nKung Tse dice al respecto: «Aquello que armoniza en el tono, vibra de consuno. Aquello que responde en el fuero más íntimo a afinidades electivas, se busca recíprocamente. El agua fluye hacia lo húmedo, el fuego se dirige hacia lo seco. Las nubes (aliento del cielo) siguen al dragón; el viento (aliento de la tierra) sigue al tigre. Así pues, se levanta el sabio y todos los seres dirigen hacia él la mirada. Lo que es oriundo del cielo se siente afín con lo que se halla en las alturas. Lo que es oriundo de la tierra se siente afín con lo que está abajo. Cada cosa sigue a su especie».'
          },
          {
            text: 'Dragón soberbio tendrá que arrepentirse.',
            explanation:
              'Cuando alguien pretende ascender tan alto que pierde el contacto directo con el resto de los hombres, se torna solitario y esto, necesariamente, conduce al fracaso. Hay aquí una advertencia contra la ambición titánica que supera las propias fuerzas. Una brusca caída al abismo sería la consecuencia.'
          },
          {
            text: 'Aparece un conjunto de dragones sin cabeza. ¡Ventura!',
            explanation:
              "Cuando todas las líneas son nueves, el signo entero entra en movimiento y se transforma en el signo k'un, lo receptivo, cuyo carácter es la ferviente entrega. Se unen la fortaleza de lo creativo y la dulzura de lo receptivo. Lo fuerte está señalado por la grey de dragones, lo suave por la circunstancia de que sus cabezas estén ocultas. Esto significa: suavidad en el modo de actuar, unida a la fuerza de la resolución, trae ventura."
          }
        ]
      }
    },
    '2': {
      title: 'Lo receptivo'
    },
    '3': {
      title: 'La dificultad inicial'
    },
    '4': {
      title: 'La necedad juvenil'
    },
    '5': {
      title: 'La espera (la alimentación)'
    },
    '6': {
      title: 'El conflicto (el pleito)'
    },
    '7': {
      title: 'El ejército'
    },
    '8': {
      title: 'La solidaridad (el mantenerse unido)'
    },
    '9': {
      title: 'La fuerza domesticadora de lo pequeño'
    },
    '10': {
      title: 'El porte (la pisada)'
    },
    '11': {
      title: 'La paz'
    },
    '12': {
      title: 'El estancamiento'
    },
    '13': {
      title: 'Comunidad con los hombres'
    },
    '14': {
      title: 'La posesion de lo grande'
    },
    '15': {
      title: 'La modestia'
    },
    '16': {
      title: 'El entusiasmo'
    },
    '17': {
      title: 'El seguimiento'
    },
    '18': {
      title: 'El trabajo en lo echado a perder'
    },
    '19': {
      title: 'El acercamiento'
    },
    '20': {
      title: 'La contemplación (la vista)'
    },
    '21': {
      title: 'La mordedura tajante'
    },
    '22': {
      title: 'La gracia (lo agraciado)'
    },
    '23': {
      title: 'La desintegración'
    },
    '24': {
      title: 'El retorno (el tiempo del solsticio)'
    },
    '25': {
      title: 'La inocencia (lo inesperado)'
    },
    '26': {
      title: 'La fuerza domesticadora de lo grande'
    },
    '27': {
      title: 'Las comisuras de la boca (la nutrición)'
    },
    '28': {
      title: 'La preponderancia de lo grande'
    },
    '29': {
      title: 'Lo abismal, el agua'
    },
    '30': {
      title: 'Lo adherente, el fuego'
    },
    '31': {
      title: 'El influjo (el cortejo)'
    },
    '32': {
      title: 'La duración'
    },
    '33': {
      title: 'La retirada'
    },
    '34': {
      title: 'El poder de lo grande'
    },
    '35': {
      title: 'El progreso'
    },
    '36': {
      title: 'El oscurecimiento de la luz'
    },
    '37': {
      title: 'El clan (la familia)'
    },
    '38': {
      title: 'El antagonismo (la oposición)'
    },
    '39': {
      title: 'El impedimento'
    },
    '40': {
      title: 'La liberación'
    },
    '41': {
      title: 'La merma'
    },
    '42': {
      title: 'El aumento'
    },
    '43': {
      title: 'El desbordamiento (la resolución)'
    },
    '44': {
      title: 'El ir al encuentro (la complacencia)'
    },
    '45': {
      title: 'La reunión (la recolección)'
    },
    '46': {
      title: 'La subida (el empuje hacia arriba)'
    },
    '47': {
      title: 'La desazón (la opresión) (el agotamiento)'
    },
    '48': {
      title: 'El pozo de agua'
    },
    '49': {
      title: 'La revolución (la muda)'
    },
    '50': {
      title: 'El caldero'
    },
    '51': {
      title: 'Lo suscitativo (la conmoción, el trueno)'
    },
    '52': {
      title: 'El aquietamiento, la montaña'
    },
    '53': {
      title: 'La evolución (progreso paulatino)'
    },
    '54': {
      title: 'La muchacha que se casa'
    },
    '55': {
      title: 'La plenitud'
    },
    '56': {
      title: 'El andariego'
    },
    '57': {
      title: 'Lo suave (lo penetrante, el viento)'
    },
    '58': {
      title: 'Lo sereno, el lago'
    },
    '59': {
      title: 'La disolución (la dispersión)'
    },
    '60': {
      title: 'La restricción'
    },
    '61': {
      title: 'La verdad interior'
    },
    '62': {
      title: 'La preponderancia de lo pequeño'
    },
    '63': {
      title: 'Después de la consumación'
    },
    '64': {
      title: 'Antes de la consumación'
    }
    // n: {
    //   title: '',
    //   judgement: '',
    //   explanation: '',
    //   image: '',
    //   lines: {
    //     explanation: '',
    //     detail: ['', '', '', '', '', '', '']
    //   }
    // }
  },
  en: {
    authors: 'Richard Wilhelm, rendered into English by Cary F. Baynes'
    // '1': {
    //   title: 'The creative',
    //   description:
    //     'The first hexagram is made up of six unbroken lines. These unbroken lines stand for the primal power, which is light-giving, active, strong, and of the spirit. The hexagram is consistently strong in character, and since it is without weakness, its essence is power or energy. Its image is heaven. Its energy is represented as unrestricted by any fixed conditions in space and is therefore conceived of as motion. Time is regarded as the basis of this motion. Thus the hexagram includes also the power of time and the power of persisting in time, that is, duration.\nThe power represented by the hexagram is to be interpreted in a dual sense in terms of its action on the universe and of its action on the world of men. In relation to the universe, the hexagram expresses the strong, creative action of the Deity. In relation to the human world, it denotes the creative action of the holy man or sage, of the ruler or leader of men, who through his power awakens and develops their higher nature.',
    //   judgement:
    //     'The Creative works sublime success, furthering through perseverance.',
    //   explanation:
    //     'According to the original meaning, the attributes [sublimity, potentiality of success, power to further, perseverance] are paired. When an individual draws this oracle, it means that success will come to him from the primal depths of the universe and that everything depends upon his seeking his happiness and that of others in one way only, that is, by perseverance in what is right.\nThe specific meanings of the four attributes became the subject of speculation at an early date. The Chinese word here rendered by "sublime" means literally "head", "origin", "great". This is why Confucius says in explaining it: "Great indeed is the generating power of the Creative; all beings owe their beginning to it. This power permeates all heaven". For this attribute inheres in the other three as well.\nThe beginning of all things lies still in the beyond in the form of ideas that have yet to become real. But the Creative furthermore has power to lend form to these archetypes of ideas. This is indicated in the word success, and the process is represented by an image from nature: "The clouds pass and the rain does its work, and all individual beings flow into their forms. "\nApplied to the human world, these attributes show the great man the way to notable success: "Because he sees with great clarity and cause and effects, he completes the six steps at the right time and mounts toward heaven on them at the right time, as though on sic dragons. " The six steps are the six different positions given in the hexagram, which are represented later by the dragon symbol. Here it is shown that the way to success lies in apprehending and giving actuality to the way of the universe [Tao], which, as a law running through end and beginning, brings about all phenomena in time. Thus each step attained forthwith becomes a preparation for the next. Time is no longer a hindrance but the means of making actual what is potential.\nThe act of creation having found expression in the two attributes sublimity and success, the work of conservation is shown to be a continuous actualization and differentiation of form. This is expressed in the two terms "furthering" (literally, "creating that which accords with the nature of a given being") and "persevering" (literally, "correct and firm"). "The course of the Creative alters and shapes beings until each attains its true, specific nature, then it keeps them in conformity with the Great Harmony. Thus does it show itself to further through perseverance. "\nIn relation to the human sphere, this shows how the great man brings peace and security to the world through his activity in creating order: "He towers high above the multitude of beings, and all lands are united in peace. "\nAnother line of speculation goes still further in separating the words "sublime," "success," "furthering," "perseverance," and parallels them with the four cardinal virtues in humanity. To sublimity, which, as the fundamental principle, embraces all the other attributes, it links love. To the attribute success are linked the morals, which regulate and organize expressions of love and thereby make them successful. The attribute furthering is correlated with justice, which creates the conditions in which each receives that which accords with his being, that which is due him and which constitutes his happiness. The attribute perseverance is correlated with wisdom, which discerns the immutable laws of all that happens and can therefore bring about enduring conditions. These speculations, already broached in the commentary called Wên Yen , later formed the bridge connecting the philosophy of the "five stages (elements) of change," as laid down in the Book of History (Shu Ching) with the philosophy of the Book of Changes, which is based solely on the polarity of positive and negative principles. In the course of time this combination of the two systems of thought opened the way for an increasingly intricate number symbolism.\n',
    //   image: {
    //     text: 'The movement of heaven is full of power. Thus the superior man makes himself strong and untiring.',
    //     explanation:
    //       "Since there is only one heaven, the doubling of the trigram Ch'ien, of which heaven is the image, indicates the movement of heaven. One complete revolution of heaven makes a day, and the repetition of the trigram means that each day is followed by another. This creates the idea of time. Since it is the same heaven moving with untiring power, there is also created the idea of duration both in and beyond time, a movement that never stops nor slackens, just as one day follows another in an unending course. This duration in time is the image of the power inherent in the Creative.\nWith this image as a model, the sage learns how best to develop himself so that his influence may endure. He must make himself strong in every way, by consciously casting out all that is inferior and degrading. Thus he attains that tirelessness which depends upon consciously limiting the fields of his activity."
    //   },
    //   lines: {
    //     detail: [
    //       {
    //         text: 'Hidden dragon. Do not act.',
    //         explanation:
    //           "In China the dragon has a meaning altogether different from that given it in the Western world. The dragon is a symbol of the electrically charged, dynamic, arousing force that manifests itself in the thunderstorm. In winter this energy withdraws into the earth; in the early summer it becomes active again, appearing in the sky as thunder and lightning. As a result the creative forces on earth begin to stir again.\nHere this creative force is still hidden beneath the earth and therefore has no effect. In terms of human affairs, this symbolizes a great man who is still unrecognized. Nonetheless he remains true to himself. He does not allow himself to be influenced by outward success or failure, but confident in his strength, he bides his time. Hence it is wise for the man who consults the oracle and draws this line to wait in the calm strength of patience. The time will fulfill itself. One need not fear lest strong will should not prevail; the main thing is not to expend one's powers prematurely in an attempt to obtain by force something for which the time is not yet ripe."
    //       },
    //       {
    //         text: 'Dragon appearing in the field. It furthers one to see the great man.',
    //         explanation:
    //           'Here the effects of the light-giving power begin to manifest themselves. In terms of human affairs, this means that the great man makes his appearance in his chosen field of activity. As yet he has no commanding position but is still with his peers. However, what distinguishes him form the others is his seriousness of purpose, his unqualified reliability, and the influence he exerts on his environment with out conscious effort. Such a man is destined to gain great influence and to set the world in order. Therefore it is favorable to see him.'
    //       },
    //       {
    //         text: 'All day long the superior man is creatively active. At nightfall his mind is still beset with cares. Danger. No blame.',
    //         explanation:
    //           'A sphere of influence opens up for the great man. His fame begins to spread. The masses flock to him. His inner power is adequate to the increased outer activity. There are all sorts of things to be done, and when others are at rest in the evening, plans and anxieties press in upon him. But danger lurks here at the place of transition from lowliness to the heights. Many a great man has been ruined because the masses flocked to him and swept him into their course. Ambition has destroyed his integrity. However, true greatness is not impaired by temptations. He who remains in touch with the time that is dawning, and with its demands is prudent enough to avoid all pitfalls, and remains blameless.'
    //       },
    //       {
    //         text: 'Wavering flight over the depths. No blame.',
    //         explanation:
    //           'A place of transition has been reached, and free choice can enter in. A twofold possibility is presented to the great man: he can soar to the heights and play an important part in the world, or he can withdraw into solitude and develop himself. He can go the way of the hero or that of the holy sage who seeks seclusion. There is no general law of his being. If the individual acts consistently and is true to himself, he will find the way that is appropriate for him. This way is right for him and without blame.'
    //       },
    //       {
    //         text: 'Flying dragon in the heavens. It furthers one to see the great man.',
    //         explanation:
    //           'Here the great man has attained the sphere of the heavenly beings. His influence spreads and becomes visible throughout the whole world. Everyone who sees him may count himself blessed. Confucius says about this line:\nThings that accord in tone vibrate together. Things that have affinity in their inmost natures seek one another. Water flows to what is wet, fire turns to what is dry. Clouds (the breath of heaven) follow the dragon, wind (the breath of earth) follows the tiger. Thus the sage arises, and all creatures follow him with their eyes. What is born of heaven feels related to what is above. What is born of earth feels related to what is below. Each follows its kind.'
    //       },
    //       {
    //         text: 'Arrogant dragon will have cause to repent.',
    //         explanation:
    //           "When a man seeks to climb so high that he loses touch with the rest of mankind, he becomes isolated, and this necessarily leads to failure. This line warns against titanic aspirations that exceed one's power. A precipitous fall would follow."
    //       },
    //       {
    //         text: 'There appears a flight of dragons without heads. Good fortune.',
    //         explanation:
    //           "When all the lines are nines, it means that the whole hexagram is in motion and changes into the hexagram K'un, THE RECEPTIVE, whose character is devotion. The strength of the Creative and the mildness of the Receptive unite. Strength is indicated by the flight of dragons, mildness by the fact that their heads are hidden. This means that mildness in action joined to strength of decision brings good fortune."
    //       }
    //     ]
    //   }
    // },
    // '2': {
    //   title: '',
    // },
    // '3': {
    //   title: '',
    // },
    // '4': {
    //   title: '',
    // },
    // '5': {
    //   title: '',
    // },
    // '6': {
    //   title: '',
    // },
    // '7': {
    //   title: '',
    // },
    // '8': {
    //   title: '',
    // },
    // '9': {
    //   title: '',
    // },
    // '10': {
    //   title: '',
    // },
    // '11': {
    //   title: '',
    // },
    // '12': {
    //   title: '',
    // },
    // '13': {
    //   title: '',
    // },
    // '14': {
    //   title: '',
    // },
    // '15': {
    //   title: '',
    // },
    // '16': {
    //   title: '',
    // },
    // '17': {
    //   title: '',
    // },
    // '18': {
    //   title: '',
    // },
    // '19': {
    //   title: '',
    // },
    // '20': {
    //   title: '',
    // },
    // '21': {
    //   title: '',
    // },
    // '22': {
    //   title: '',
    // },
    // '23': {
    //   title: '',
    // },
    // '24': {
    //   title: '',
    // },
    // '25': {
    //   title: '',
    // },
    // '26': {
    //   title: '',
    // },
    // '27': {
    //   title: '',
    // },
    // '28': {
    //   title: '',
    // },
    // '29': {
    //   title: '',
    // },
    // '30': {
    //   title: '',
    // },
    // '31': {
    //   title: '',
    // },
    // '32': {
    //   title: '',
    // },
    // '33': {
    //   title: '',
    // },
    // '34': {
    //   title: '',
    // },
    // '35': {
    //   title: '',
    // },
    // '36': {
    //   title: '',
    // },
    // '37': {
    //   title: '',
    // },
    // '38': {
    //   title: '',
    // },
    // '39': {
    //   title: '',
    // },
    // '40': {
    //   title: '',
    // },
    // '41': {
    //   title: '',
    // },
    // '42': {
    //   title: '',
    // },
    // '43': {
    //   title: '',
    // },
    // '44': {
    //   title: '',
    // },
    // '45': {
    //   title: '',
    // },
    // '46': {
    //   title: '',
    // },
    // '47': {
    //   title: '',
    // },
    // '48': {
    //   title: '',
    // },
    // '49': {
    //   title: '',
    // },
    // '50': {
    //   title: '',
    // },
    // '51': {
    //   title: '',
    // },
    // '52': {
    //   title: '',
    // },
    // '53': {
    //   title: '',
    // },
    // '54': {
    //   title: '',
    // },
    // '55': {
    //   title: '',
    // },
    // '56': {
    //   title: '',
    // },
    // '57': {
    //   title: '',
    // },
    // '58': {
    //   title: '',
    // },
    // '59': {
    //   title: '',
    // },
    // '60': {
    //   title: '',
    // },
    // '61': {
    //   title: '',
    // },
    // '62': {
    //   title: '',
    // },
    // '63': {
    //   title: '',
    // },
    // '64': {
    //   title: '',
    // },
    // n: {
    //   title: '',
    //   judgement: '',
    //   explanation: '',
    //   image: '',
    //   lines: {
    //     explanation: '',
    //     detail: ['', '', '', '', '', '', '']
    //   }
    // }
  }
};

const book: Book = {
  id: 'Wilhelm',
  translation
};

export default book;
